$(document).ready(function() {
    // Prepend the HTML Content in the body

    // ============= DEFAULT CONTENTS
  
    var qualityMatters_Default = `
      <p>- We spend a third of our life sleeping. 2,891 hours every single year.</p>
      <p>- And quality sleep is one of the MOST important factors in overall health. Did you know that poor sleep triggers insulin resistance, cognitive decline, mental health issues, and has even been linked to cardiovascular disease?</p>
      <p>- Your pillow can make or break the quality of your sleep. We were tired of sleeping on pillows filled with that fall flat, provide no support, and literally cause neck pain and headaches. We’re talking about those those hotel pillows that you need 4 of just to feel supported — yeah, those ones.</p>
      <p>- So we set out to develop the perfect pillow. One that provides the perfect balance of comfort and support. One that keeps aligns your neck and spine in alignment to reduce neck pain and tension headaches. And one that is suitable for all types of sleepers — back, side, stomach, and combination.</p>
      <p>- Dosaze isn’t a discount brand. Dosaze is a premium product (did you know that a mattress built from Dosaze memory foam would cost $4,000?)</p>
      <p>- We exist for the sole purpose of creating your perfect night’s sleep. That’s why we spent 2 years developing this product and perfecting every detail — from the density of the foam, to the shape, to the cover.</p>
      <p>- This will be the best $119 you ever invest in your sleep.</p>
      <p>- The measure of a purchase isn’t the feeling you get when you make it; it’s the feeling you get when you wake up every day, refreshed, and ready to take on the day.</p>
    `;

    var returnProcess_Default = `
      <p>All orders can be returned within 60 days from delivery. We offer a 60-day night sleep trial on all orders, so you are welcome to return the pillow, even after you have used it.</p>
      <p>Buying pillows online can be a very strange process since pillows are naturally a subjective item. We all want to try a pillow before committing to purchase it, and here at Dosaze, we completely understand that.</p>
      <p>That’s why we offer a 60-night sleep trial on all orders so you can test the pillow in the comfort of your own home and eliminate any doubts you may have. Starting from when you receive your package, you have 60 nights!</p>
      <p>If you’re not in love with your purchase during this time period, you have the option to return It to us for a full refund. Simply reach out to <a href="mailto:support@dosaze.com" style="text-decoration:underline;">support@dosaze.com</a> to initiate a return. </p>
    `;

    var howWeDidIt_Default = `
      <p></p>
      <h3>For the side, back, or combination sleeper that wakes up with neck pain and headaches, and is tired of it.</h3>
      <p></p>
      <p>Welcome Home.</p>
      <p>A recent poll showed that 80% of people experience neck pain in their life and an additional 80% experience tension headaches. Poor sleep alignment can be a primary cause of this, but most pillows do nothing to improve that.</p>
      <p>How does that even make sense?</p>
      <p>Of course, that would be okay if we all naturally slept aligned, but you know that isn’t the case.</p>
      <p>Some pillows may keep you aligned if you’re a side sleepers, some others if you’re a back sleeper, but rarely do you come across a pillow that will keep you all sleepers aligned.</p>
      <p>Your body is a solider. It works overtime to undo, correct, and fix your bad habits. The way you sit, the way you walk, and the way you sleep.</p>
      <p>But, like a credit card, your body can only accumulate so much debt before something has to give.</p>
      <p>
        <strong>Here’s what happens when you send a regular pillow to do the job of a Dosaze Contoured Orthopedic Pillow</strong>
      </p>
      <p>
        <img src="https://cdn.shopify.com/s/files/1/0306/1081/7162/files/dosaze-pillow-alignment.png?v=1687190382">
      </p>
      <p>For a number of reasons, these pillows simply do not facilitate aligned sleep.</p>
      <p>First, they <strong>do not provide adequate support</strong>— these pillows are often filled with microfiber or other low quality materials that tend to fall flat when you lie on them. You know, like those hotel pillows that you need to use 3 - 4 of just to feel supported. You can see how this would cause poor alignment. </p>
      <p>Second, the "standard" pillow shape <strong>isn’t catered to the natural alignment of your spine, neck, and head</strong>. In general, you want a pillow that gradually slopes up for a back sleeper. For a side sleeper, you actually want a pillow that is higher in the front and slightly lower in the back, to fit the shape your shoulder and head make together. </p>
      <p>This improper support and alignment are the primary causes of neck pain and tension headaches. You probably have tried other solutions — a new mattress, visits to the chiropractor, and/or pain medication — none of which are cheap and definitely add up over time.</p>
      <p>
        <strong>Enough Already!</strong>
      </p>
      <p>You don’t need more helpful hints, tips, or tricks. You just need a pillow designed with you in mind.</p>
      <p>
        <strong>The "weirdly" shaped pillow</strong>
      </p>
      <p>If you ask a carpenter to make you a table it’s going to be made out of wood. You ask a welder to do it, your table is going to be made out of metal.</p>
      <p>So when the legacy pillow makers try to make a pillow for side sleepers, they get so focused on making it look like a pillow that they forget to focus on the quality of sleep problem.</p>
      <p>We didn’t have that kind of baggage. We didn’t have to unlearn 50 years of pillow design.</p>
      <p>Starting from scratch has its advantages. And the need for a "contoured" pillow was clear to us early.</p>
      <p>The contoured shaped allowed for perfect alignment for side, back, and stomach sleepers (and all combinations).</p>
      <p>The center contour is perfect for keeping your head and neck and alignment when you’re on your back or stomach.</p>
      <p></p>
      <p>If you sleep on your side, the elevated bolsters fill your shoulder gap and the back gradually slopes down to fit the natural curvature of your head:</p>
      <p></p>
      <p>
        <img src="https://cdn.shopify.com/s/files/1/0306/1081/7162/files/dosaze-pillow-alignment-2.png?v=1687190382">
      </p>
      <p></p>
      <p>And the best part? <strong> If you sleep on your back and side, you can roll from the elevated side bolsters to the center contour and maintain your spinal alignment in either position.</strong>
      </p>
      <p>It’s not just about the shape though.</p>
      <p>If it was just the shape that mattered, we would have used microfiber, down, or other materials that aren’t supportive. However, we were on the hunt for the perfect foam blend.</p>
      <p>Not too hard (it would hurt your ear), not too soft (it wouldn’t support your spin), and definitely not something too hot. It needed to be just right.</p>
      <p>We tested ~50 different foam blends and firmness levels with people from all walks of life. Some started off promising and in the end all failed. It was so hard we nearly abandoned the project. In the end we did something experts told us we would never be able to do: we created our own proprietary blend.</p>
      <p>This pillow couldn’t have existed 5 years ago</p>
      <p>There is a reason you didn’t see us when you shopped for your last pillow. The technology behind the Dosaze Contoured Orthopedic Pillow didn’t exist.</p>
      <p>We crafted this pillow to solve the support and alignment issues plaguing us and our loved ones — we saw the issues with current pillows and solved them meticulously one by one.</p>
      <p>We use only the highest CertiPUR-US certified memory foam. In fact the foam used for your Dosaze Contoured Orthopedic Pillow is so high quality that it would retail for <span class="reveal">REVEAL</span> dollars if we were to build a mattress using it. </p>
      <p>
        <strong>If you’ve made it this far, we want to say thank you. Thank you for allowing us to share our journey to create the perfect pillow with you.</strong>
      </p>
      <p>There’s a lot of pressure to buy now, act now. Don’t feel rushed. We aren’t going anywhere. And when you’re ready we look forward to give you the best quality sleep of your lift. If you have any questions, you can reach our cofounders Inno and Sherry directly @ <a href="mailto:inno@dosaze.com">
          <strong>inno@dosaze.com</strong>
        </a> and <a href="mailto:sherry@dosaze.com">
          <strong>sherry@dosaze.com</strong>
        </a> and we can answer any questions you have! </p>
      <p>And if you try it, and our pillow doesn’t help you, no harm no foul. You can try our pillow for 60 nights and get a full refund, no questions asked, if you don’t like it.</p>
      <p>We look forward to you joining the millions that are sleeping better with Dosaze.</p>
    `;

    // ============= CONTENT AVAILABLE
  
    if ($('#QMContent').length > 0) {
        var qualityMatters_Content = $('#QMContent').html();
    } else {
        var qualityMatters_Content = qualityMatters_Default;
    }

    if ($('#RPContent').length > 0) {
        var returnProcess_Content = $('#RPContent').html();
    } else {
        var returnProcess_Content = returnProcess_Default;
    }

    if ($('#HWContent').length > 0) {
        var howWeDidIt_Content = $('#HWContent').html();
    } else {
        var howWeDidIt_Content = howWeDidIt_Default;
    }

    // ============= HTML LAYOUT
  
    var qualityMatters_HTML = `
      <div class="qm qm-matters" style="display:none;">
          <div class="qm-wrapper">
              <a href="#" class="qm-close">
              <i class="fa-thin fa-xmark"></i>
              </a>
              <div class="qm-content">
              ` + qualityMatters_Content + `
              </div>
              <div class="qm-agree">
              <div class="qm-option">Agree with our stance on quality?</div>
              <div class="qm-option">
                  <a href="#" id="qm-answer" class="qm-yes" data-qm-answer="yes">Yes</a>
                  <a href="#" id="qm-answer" class="qm-no" data-qm-answer="no">No</a>
              </div>
              </div>
          </div>
      </div>
    `;
  
    var returnProcess_HTML = `
    <div class="qm qm-return" style="display:none;">
        <div class="qm-wrapper">
        <a href="#" class="qm-close">
            <i class="fa-thin fa-xmark"></i>
        </a>
        <div class="qm-content">
        ` + returnProcess_Content + `
        </div>
        </div>
    </div>
    `;

    var howWeDidIt_HTML = `
    <div class="spt" style="display:none;">
      <div class="spt-container">
        <div class="spt-close">
          <a href="#" class="spt-close-link">
            <i class="fa-solid fa-xmark spt-close-icon"></i>
          </a>
        </div>
        <div class="spt-content">
          ` + howWeDidIt_Content + `
        </div>
      </div>
    </div>
    `;
  
    // ============= PREPEND
    if ($('.qm.qm-matters').length === 0) {
      $('body').prepend(qualityMatters_HTML);
    }

    // Return Process
    if ($('.qm.qm-return').length === 0) {
      $('body').prepend(returnProcess_HTML);
    }
  
    // How We Did It
    if ($('.spt').length === 0) {
      $('body').prepend(howWeDidIt_HTML);
    }
  
    // Replace the .dz-returns to this content
    $('.dz-returns:not([data-added])').each(function() {
      if ($(this).closest('.section--featured-product-above').length === 0) {
        $(this).replaceWith('<div class="qm-section-wrapper"><div class="qm-btn-wrapper"><div class="qm-btn-holder"><a href="#" data-added style="display: inline-block;" class="quality-matters"><i class="fa-thin fa-award"></i>&nbsp;Why Does Quality Matter?</a></div><div class="qm-btn-holder"><a href="#" class="dz-returns" data-added><i class="fa-light fa-truck"></i>&nbsp;Our FREE RETURNS PROCESS</a></div></div></div>');
      } else {
        $(this).replaceWith(`
          <div class="qm-section-wrapper">
            <div class="qm-btn-wrapper">
              <div class="qm-btn-holder">
                <a href="#" data-added style="display: inline-block;" class="quality-matters">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.39461 2.13356C6.23226 2.27191 6.15108 2.3411 6.06438 2.3992C5.86565 2.5324 5.64245 2.62485 5.40774 2.67119C5.30535 2.69141 5.19903 2.69989 4.98639 2.71686C4.45214 2.7595 4.18501 2.78081 3.96215 2.85953C3.44668 3.0416 3.04123 3.44705 2.85916 3.96252C2.78044 4.18537 2.75913 4.45251 2.71649 4.98676C2.69952 5.19939 2.69104 5.30571 2.67082 5.40811C2.62448 5.64282 2.53203 5.86601 2.39883 6.06475C2.34073 6.15145 2.27155 6.23262 2.13319 6.39497C1.78556 6.80291 1.61174 7.00684 1.50982 7.22011C1.27407 7.71338 1.27407 8.28671 1.50982 8.77997C1.61175 8.99324 1.78556 9.19718 2.13319 9.60511C2.27153 9.76744 2.34073 9.84864 2.39883 9.93531C2.53203 10.134 2.62448 10.3572 2.67082 10.5919C2.69104 10.6943 2.69952 10.8007 2.71649 11.0133C2.75913 11.5475 2.78044 11.8147 2.85916 12.0375C3.04123 12.553 3.44668 12.9585 3.96215 13.1405C4.18501 13.2192 4.45214 13.2405 4.98639 13.2832C5.19903 13.3001 5.30535 13.3087 5.40774 13.3289C5.64245 13.3752 5.86565 13.4677 6.06438 13.6009C6.15108 13.6589 6.23225 13.7281 6.39461 13.8665C6.80254 14.2141 7.00647 14.3879 7.21974 14.4899C7.71301 14.7256 8.28634 14.7256 8.77961 14.4899C8.99287 14.3879 9.19681 14.2141 9.60474 13.8665C9.76707 13.7281 9.84827 13.6589 9.93494 13.6009C10.1336 13.4677 10.3568 13.3752 10.5916 13.3289C10.694 13.3087 10.8003 13.3001 11.0129 13.2832C11.5472 13.2405 11.8143 13.2192 12.0372 13.1405C12.5526 12.9585 12.9581 12.553 13.1402 12.0375C13.2188 11.8147 13.2402 11.5475 13.2828 11.0133C13.2998 10.8007 13.3083 10.6943 13.3285 10.5919C13.3748 10.3572 13.4673 10.134 13.6005 9.93531C13.6586 9.84864 13.7278 9.76744 13.8661 9.60511C14.2138 9.19718 14.3876 8.99324 14.4895 8.77997C14.7252 8.28671 14.7252 7.71338 14.4895 7.22011C14.3876 7.00684 14.2138 6.80291 13.8661 6.39497C13.7278 6.23262 13.6586 6.15145 13.6005 6.06475C13.4673 5.86601 13.3748 5.64282 13.3285 5.40811C13.3083 5.30571 13.2998 5.19939 13.2828 4.98676C13.2402 4.45251 13.2188 4.18537 13.1402 3.96252C12.9581 3.44705 12.5526 3.0416 12.0372 2.85953C11.8143 2.78081 11.5472 2.7595 11.0129 2.71686C10.8003 2.69989 10.694 2.69141 10.5916 2.67119C10.3568 2.62485 10.1336 2.5324 9.93494 2.3992C9.84827 2.3411 9.76707 2.27192 9.60474 2.13356C9.19681 1.78593 8.99287 1.61212 8.77961 1.51019C8.28634 1.27444 7.71301 1.27444 7.21974 1.51019C7.00647 1.61211 6.80254 1.78593 6.39461 2.13356ZM10.9153 6.57547C11.1272 6.36357 11.1272 6.02004 10.9153 5.80815C10.7034 5.59626 10.3598 5.59626 10.148 5.80815L6.91454 9.04164L5.85131 7.97844C5.63943 7.76657 5.29589 7.76657 5.084 7.97844C4.87211 8.19031 4.87211 8.53384 5.084 8.74577L6.53086 10.1926C6.74274 10.4045 7.08627 10.4045 7.29821 10.1926L10.9153 6.57547Z" fill="white"/>
                  </svg>
                  quality pledge
                </a>
              </div>
              <div class="qm-btn-holder">
                <a href="#" class="dz-returns" data-added>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M15.6 10.4H15.2V7.69748C15.2 7.37998 15.0725 7.07498 14.8475 6.84998L12.35 4.35248C12.125 4.12748 11.82 3.99998 11.5025 3.99998H10.4V2.79998C10.4 2.13748 9.8625 1.59998 9.2 1.59998H2.8C2.1375 1.59998 1.6 2.13748 1.6 2.79998V3.99998H0.2C0.09 3.99998 0 4.08998 0 4.19998V4.59998C0 4.70998 0.09 4.79998 0.2 4.79998H7C7.11 4.79998 7.2 4.88998 7.2 4.99998V5.39998C7.2 5.50998 7.11 5.59998 7 5.59998H1C0.89 5.59998 0.8 5.68998 0.8 5.79998V6.19998C0.8 6.30998 0.89 6.39998 1 6.39998H6.2C6.31 6.39998 6.4 6.48998 6.4 6.59998V6.99998C6.4 7.10998 6.31 7.19998 6.2 7.19998H0.2C0.09 7.19998 0 7.28998 0 7.39998V7.79998C0 7.90998 0.09 7.99998 0.2 7.99998H5.4C5.51 7.99998 5.6 8.08998 5.6 8.19998V8.59998C5.6 8.70998 5.51 8.79998 5.4 8.79998H1.6V12C1.6 13.325 2.675 14.4 4 14.4C5.325 14.4 6.4 13.325 6.4 12H9.6C9.6 13.325 10.675 14.4 12 14.4C13.325 14.4 14.4 13.325 14.4 12H15.6C15.82 12 16 11.82 16 11.6V10.8C16 10.58 15.82 10.4 15.6 10.4ZM4 13.2C3.3375 13.2 2.8 12.6625 2.8 12C2.8 11.3375 3.3375 10.8 4 10.8C4.6625 10.8 5.2 11.3375 5.2 12C5.2 12.6625 4.6625 13.2 4 13.2ZM12 13.2C11.3375 13.2 10.8 12.6625 10.8 12C10.8 11.3375 11.3375 10.8 12 10.8C12.6625 10.8 13.2 11.3375 13.2 12C13.2 12.6625 12.6625 13.2 12 13.2ZM14 7.99998H10.4V5.19998H11.5025L14 7.69748V7.99998Z" fill="white"/>
                  </svg>
                  return process
                </a>
              </div>
            </div>
          </div>
        `);
      }
    });

    // Add How We Did It Button
    $('.product-single__meta div[data-product-blocks]:not(:has(.sales-pitch-trigger))').append('<div class="product-block"><a href="#" class="sales-pitch-trigger"><i class="fa-thin fa-circle-question"></i> How We Did It</a></div>');
});

// Quality Matters
$(document).on('click', '.quality-matters', function(event) {
  event.preventDefault();
  if ($('.qm-matters').length > 0) {
    $('.qm-matters').first().show();
  }
});

// Return Process
$(document).on('click', '.dz-returns', function(event) {
  event.preventDefault();
  if ($('.qm-return').length > 0) {
    $('.qm-return').first().show();
  }
});

// Long Pitch
$(document).on('click', '.sales-pitch-trigger', function(event) {
  event.preventDefault();
  if ($('.spt').length > 0) {
    $('.spt').first().show();
  }
})

// Close Button
$(document).on('click', '.qm-close, .spt-close', function(event) {
  event.preventDefault();
  $(this).parent().parent().hide();
});

// Close any open popup with the Escape key
$(document).on('keydown', function(event) {
  if (event.key === 'Escape') {
    $('.qm, .spt').hide();
    $('.dz-lightbox-content').fadeOut();
  }
});

// Quality Matters Answer
$(document).on('click', '#qm-answer', function(event) {
  event.preventDefault();
  $('.qm-agree').hide();
});

$(document).on('click', '.spt .reveal', function(event) {
  event.preventDefault();
  $(this).text('$4000');
});

$(document).on('click', '.product-popup-close', function(event) {
  event.preventDefault();
  $(this).parent().parent().fadeOut();
});

$(document).on('click', '.product-popup-show', function(event) {
    event.preventDefault(); 
    var ppid = $(this).attr('id'); 
    $('#' + ppid).show(); 
});

// ================================= NEW POPUP ================================= 

$(document).ready(function() {
  // Open the lightbox and load the corresponding content
  $(document).on('click', '.dz-info-popup-btn', function(e) {
    e.preventDefault(); // Prevent default anchor behavior

    var targetId = $(this).attr('id').replace('-btn', ''); // Get the target ID without '-btn'
    var content = $('#' + targetId + '-content').html(); // Get the corresponding hidden content
            
    // Insert the content into the lightbox
    $('.dz-lightbox-content .product-block').html(content);

    // Check local storage to see if the user has already answered the question for this trigger
    var hasAnswered = localStorage.getItem(targetId + '-answered');

    // Show the agreement section only if the user hasn't answered the question
    if (hasAnswered) {
      $('.dz-agreement-section').hide(); // Hide agreement section if already answered
    } else if ($(this).hasClass('dz-info-agreement-active')) {
      $('.dz-agreement-section').show(); // Show agreement section if class is present and no answer yet
    }

    // Show the lightbox with display flex
    $('.dz-lightbox-content').css('display', 'flex').hide().fadeIn(); // Ensure display is set to flex, then fade in
  });

  // Close the lightbox
  $(document).on('click', '.dz-lightbox-content .dz-lightbox-close' ,function() {
    $('.dz-lightbox-content').fadeOut();
  });

  // Close lightbox when clicking outside the content
  $(document).on('click', '.dz-lightbox-content', function(e) {
    if ($(e.target).is('.dz-lightbox-content')) {
      $(this).fadeOut();
    }
  });

  // Handle Yes button click (store answer in localStorage)
  $(document).on('click', '.dz-agreement-section #yes-btn', function() {
    var triggerId = $('.dz-info-popup-btn.dz-info-agreement-active').attr('id').replace('-btn', '');

    // Store the answer in localStorage
    localStorage.setItem(triggerId + '-answered', 'yes');

    alert('Thank you for agreeing with our stance on quality!');
    $('.dz-lightbox-content').fadeOut();
  });

  // Handle No button click (store answer in localStorage)
  $(document).on('click', '.dz-agreement-section #no-btn', function() {
    var triggerId = $('.dz-info-popup-btn.dz-info-agreement-active').attr('id').replace('-btn', '');

    // Store the answer in localStorage
    localStorage.setItem(triggerId + '-answered', 'no');

    alert('We appreciate your feedback!');
    $('.dz-lightbox-content').fadeOut();
  });
});